import { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { twMerge } from "tailwind-merge";

function EmployeeTypeSideScroll({ employeeTypes, viewEmployeeTypeDetails }) {
  const { id } = useParams();
  const selectedCardRef = useRef(null);

  useEffect(() => {
    selectedCardRef.current?.scrollIntoView({
      block: "nearest",
      behavior: "smooth",
    });
  }, [id, employeeTypes.length]);

  return (
    <div className="w-full h-screen p-2 border-[1px] border-gray-200 rounded-lg overflow-y-auto scrollbar-thumb-gray-400 scrollbar-thin scrollbar-track-gray-200">
      {employeeTypes.map((employeeType, index) => {
        const selected = String(id) === String(employeeType.id);
        return (
          <div
            ref={selected ? selectedCardRef : null}
            className={twMerge(
              "border px-2 py-3 cursor-pointer border-gray-200 transition-colors",
              selected ? "bg-gray-200" : "hover:bg-gray-100"
            )}
            key={employeeType.id || index}
            onClick={() => viewEmployeeTypeDetails(employeeType.id)}
          >
            <div className="text-sm font-semibold text-gray-700 truncate">
              {employeeType.name}
            </div>
            <div className="mt-1 text-xs font-medium text-gray-500">
              {employeeType.statusName}
            </div>
          </div>
        );
      })}
      {employeeTypes.length < 1 ? (
        <div className="p-4 text-sm text-gray-500">No Employee Types found</div>
      ) : null}
    </div>
  );
}

export default EmployeeTypeSideScroll;
